<template>
  <h2>{{ data.title_section }}</h2>
  <div class="go1-grid">
    <div
      class="md:go1-col-6 lg:go1-col-4 go1-col-12"
      v-for="(hotel, index) in hotels"
      :key="index"
    >
      <a :href="hotel.url" class="go1-hoteles">
        <div
          class="go1-imagen"
          :style="'background-image: url(' + `${hotel.image}` + ')'"
        >
          <div
            class="go1-flex go1-flex-column go1-justify-content-between go1-w-full"
          >
            <div class="go1-flex go1-justify-content-end go1-pr-3 go1-pt-3">
              <div
                v-if="hotel.quote.discount"
                class="go1-ribbon go1-hotel-pla-principal"
              >
                <div class="">
                  {{ hotel.quote.discount }} % {{ $t("message.descuento") }}
                </div>
                <i class="go1-icon go1-hotel-icons fas fa-hotel"></i>
              </div>
            </div>
            <div>
              <div class="go1-hotel-gradient go1-px-3 go1-py-2">
                <div
                  class="go1-grid go1-grid-nogutter go1-justify-content-between go1-z-3"
                >
                  <div class="go1-col-8">
                    <div
                      class="go1-hotel-name go1-hotel-name-hotel go1-block go1-overflow-hidden go1-text-overflow-ellipsis go1-white-space-nowrap"
                    >
                      {{ hotel.name }}
                    </div>
                    <EstrellasLabel :value="hotel.stars"></EstrellasLabel>
                  </div>
                  <div class="go1-col-auto go1-align-self-center">
                    <div
                      class="go1-block go1-text-right go1-overflow-hidden go1-text-lg go1-hotel-title-destination go1-text-overflow-elipsis go1-white-space-nowrap go1-text-xl"
                    >
                      {{ hotel.destination }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="go1-contenido">
          <div class="go1-grid go1-grid-nogutter" style="height: 100%;">
            <div class="go1-col-4">
              <div
                class="go1-hotel-bg-promotion go1-hotel-text-promotion go1-justify-content-between go1-text-right go1-p-2 go1-h-full go1-flex go1-flex-column"
                style="width: 100%;box-sizing: border-box;"
              >
                <span class="text-responsive">{{ $t("message.from") }}</span>
                <span
                  v-if="hotel.quote.discount"
                  class="go1-text-translucent go1-py-1 go1-line-through text-responsive"
                >
                  <PriceLabel
                    :value="[
                      hotel.quote.prePromotionalRateWithTaxesPerNight,
                      hotel.quote.currency,
                    ]"
                  ></PriceLabel>
                </span>
                <span
                  :class="{
                    'small-text-2': hotel.quote.currency === 'COP',
                    'small-text-3': hotel.quote.currency !== 'COP',
                    'go1-py-1': hotel.quote.currency !== 'COP',
                  }"
                  style="display: block; width: 100%"
                >
                  <PriceLabel
                    :value="[
                      hotel.quote.amountTotalPerNight,
                      hotel.quote.currency,
                    ]"
                  ></PriceLabel>
                </span>
              </div>
            </div>
            <div class="go1-col-8">
              <div class="go1-grid go1-grid-nogutter go1-pl-2 go1-py-2">
                <div class="go1-col-fixed go1-fixed-icons">
                  <i class="go1-hotel-icons fas fa-bed"></i>
                </div>
                <div class="go1-col text-responsive">
                  <div>
                    {{ $t("message.from") }}:
                    <span class="go1-hotel-text">
                      <FechaLabel :value="fecha1"></FechaLabel>
                    </span>
                  </div>
                  <div>
                    {{ $t("message.to") }}:
                    <span class="go1-hotel-text">
                      <FechaLabel :value="fecha2"></FechaLabel>
                    </span>
                  </div>
                </div>
                <div class="go1-col-12 go1-px-1">
                  <hr />
                </div>
                <div class="go1-col-fixed go1-fixed-icons">
                  <i class="go1-hotel-icons fas fa-user-friends"></i>
                </div>
                <div class="go1-col go1-hotel-text">
                  {{ $t("message.personas", data.number_pax) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script setup>
const { data } = defineProps(["data"]);

import PriceLabel from "@/components/extra/PriceLabel";
import EstrellasLabel from "@/components/extra/EstrellasLabel";
import FechaLabel from "@/components/extra/FechaLabel";
import { SortType } from "@/components/extra/Sort.ts";

function obtenerProximoDia(fecha, dia) {
  var diaSemana = fecha.getDay();
  var diferenciaDias = dia - diaSemana; // Diferencia de días para llegar al próximo lunes
  if (diferenciaDias < 0) {
    diferenciaDias += 7; // Si el día actual es lunes, sumamos una semana completa
  }
  fecha.setDate(fecha.getDate() + diferenciaDias);
  return fecha;
}

let fecha1;
let fecha2;
if (data.date_type == "Personalizada") {
  fecha1 = new Date(data.date_start);
  if (data.day_start) {
    fecha1 = obtenerProximoDia(fecha1, data.day_start);
  }
  fecha2 = new Date(data.date_end);
} else if (data.date_type == "Dinamica") {
  let now = new Date();
  fecha1 = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + data.days_future
  );
  if (data.day_start) {
    fecha1 = obtenerProximoDia(fecha1, data.day_start);
  }
  fecha2 = new Date(
    fecha1.getFullYear(),
    fecha1.getMonth(),
    fecha1.getDate() + data.nights
  );
}

let fechaInicio = fecha1
  .toISOString()
  .replace(/\d\d(\d\d)-(\d\d)-(\d\d).+/, "$2/$3/$1");
let fechaFin = fecha2
  .toISOString()
  .replace(/\d\d(\d\d)-(\d\d)-(\d\d).+/, "$2/$3/$1");

let fecha1H = fecha1
  .toISOString()
  .replace(/(\d\d\d\d)-(\d\d)-(\d\d).+/, "$3/$2/$1");
let fecha2H = fecha2
  .toISOString()
  .replace(/(\d\d\d\d)-(\d\d)-(\d\d).+/, "$3/$2/$1");


  let hotelIds = data.selected_hotels.map((el) => el.code);
let blockSize = 10;
let bloquesIds = hotelIds.reduce((acc, _, i) => (i % blockSize) ? acc : [...acc, hotelIds.slice(i, i + blockSize)], []);
let hotels = [];

for (let hotelIds of bloquesIds) {
  let url =
    window.apiUri +
    "/api/quote/hotels?ChannelId=" +
    config.id +
    "&Currency=" +
    config.currency +
    "&Language=" +
    config.languageId +
    "&AffiliateSiteId=" +
    config.affiliateSiteId +
    "&Ids=" +
    hotelIds +
    "&Paxes=" +
    data.number_pax +
    "&ArrivalDate=" +
    fechaInicio +
    "&DepartureDate=" +
    fechaFin;
  let response = await fetch(url);
  let { rates } = await response.json();


  let base = window.domain;
  if (window.config.uri) {
    base = base + "/" + window.config.uri;
  }
  let url_action =
    base +
    `/QuoteFromHotelWidget?MappingType=2&Hotel.Route.Origin.Date=${fecha1H}&Hotel.Route.Destination.Date=${fecha2H}&IsPackage=false&ActionType=4&Hotel.Rooms=1&Hotel.Pax[0].Adults=${data.number_pax}&Hotel.Pax[0].Kids=0&Hotel.Pax[0].KidAges[0]=-1&Hotel.Pax[0].KidAges[1]=-1&Hotel.Pax[0].KidAges[2]=-1&Hotel.Pax[0].KidAges[3]=-1&Hotel.Pax[0].KidAges[4]=-1&Hotel.Pax[0].KidAges[5]=-1&&HotelId=`;

  for (const item of data.selected_hotels) {
    let quote = rates[item.code];
    if (quote) {
      let hotel = item;
      hotel.quote = quote;

      hotel.url = url_action + hotel.code;

      hotels.push(hotel);
    }
  }
}
if (typeof data.sort == "object") {
  switch (data.sort.id) {
    case SortType.Stars:
      hotels = hotels.sort((a, b) => b.stars - a.stars);
      break;
    case SortType.High:
      hotels = hotels.sort((a, b) => b.quote.amountTotal - a.quote.amountTotal);
      break;
    case SortType.Low:
      hotels = hotels.sort((a, b) => a.quote.amountTotal - b.quote.amountTotal);
      break;
    default:
      break;
  }
} else {
  if (data.sort == SortType.Price) {
    hotels = hotels.sort((a, b) => a.quote.amountTotal - b.quote.amountTotal);
  }
}
</script>

<style scoped>
.go1-text-yellow-500 i {
  color: orange;
}

/*DATA STYLES CLASSES*/
.render .go1-hotel-pla-principal {
  color: v-bind("#" + data.styles.c_pla_principal);
  background-color: v-bind("#" + data.styles.bg_pla_principal);
}

.render .go1-hotel-icons {
  color: v-bind("#" + data.styles.c_icons);
}

.render .go1-hotel-title-destination {
  color: v-bind("#" + data.styles.c_title_destination);
}

.render .go1-hotel-bg-promotion {
  background-color: v-bind("#" + data.styles.bg_promotion);
}

.render .go1-hotel-text-promotion {
  color: v-bind("#" + data.styles.c_promotion);
}

.render .go1-hotel-text {
  color: v-bind("#" + data.styles.c_text);
}

.render .go1-hotel-gradient {
  background: rgba(
    v-bind("data.styles.c_gradient?.r"),
    v-bind("data.styles.c_gradient?.g"),
    v-bind("data.styles.c_gradient?.b"),
    v-bind("data.styles.c_alpha")
  ) !important;
}

.render .go1-hotel-name-hotel {
  color: v-bind("#" + data.styles.c_name_hotel);
}

.render .go1-hotel-stars {
  color: v-bind("#" + data.styles.c_stars);
}

.small-text {
  font-size: 1.2em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-2 {
  font-size: 1.3em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-3 {
  font-size: 1.6em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-4 {
  font-size: 1.5em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.go1-contenido{
  flex: 1;
}
</style>
